import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0af2e3dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", {
    class: "text-field",
    style: _normalizeStyle([_ctx.$route.path.includes('no_media') ? { 'margin-top': '-20px' } : {}])
  }, [
    _createElementVNode("span", { innerHTML: _ctx.text }, null, 8, _hoisted_1)
  ], 4))
}